import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/app/hooks";
import { Bell } from "@/shared/ui/icons";
import { useShellDialogs } from "./dialogs";
import { selectUnreadNotifications } from "./legacySelectors";

/** Campanella della topbar: il contatore vive ancora nello slice legacy; la lista si apre via useShellDialogs. */
export function NotificationsBell() {
  const { t } = useTranslation();
  const { openNotifications } = useShellDialogs();
  const unread = useAppSelector(selectUnreadNotifications);
  return (
    <button
      className="icon-button btn btn-ghost btn-sm btn-square"
      aria-label={t("shell.notifications.label", { var1: unread })}
      onClick={openNotifications}
    >
      <Bell />
      <span className="notification-count">{unread}</span>
    </button>
  );
}
